import type { FormValues } from './';

export default (values: FormValues) => {
  const validationErrors = {};

  if (!values.email) {
    validationErrors.email = 'Email cannot be blank';
  }

  if (!values.password) {
    validationErrors.password = 'Password cannot be blank';
  }

  return validationErrors;
};
